module.exports = __webpack_public_path__ + "img/LTS_SAS.05ced179.gif";